import { IconProps } from '../../types/IconProps';

export const Close = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    preserveAspectRatio='xMidYMid meet'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''}`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M20.037 18.72a.931.931 0 0 1-1.317 1.317L12 13.317l-6.72 6.72a.931.931 0 0 1-1.317-1.317l6.72-6.72-6.72-6.72A.931.931 0 1 1 5.28 3.963l6.72 6.72 6.72-6.72a.931.931 0 0 1 1.317 1.317L13.317 12l6.72 6.72Z'
    />
  </svg>
);
